import { CSSObject } from '@chakra-ui/react'
import { Dict } from '@chakra-ui/utils'
import { mode } from '@chakra-ui/theme-tools'
import { DISABLED_OPACITY } from './constants'

const commonBackgroundColor = (props: Dict) => ({
  backgroundColor: mode('rw1.secondary.light.0', 'rw1.secondary.dark.0')(props),
})
const activeStyle = (props: Dict) => ({
  borderColor: mode('rw1.secondary.light.6', 'rw1.secondary.dark.6')(props),
  borderWidth: 'thin',
})

export const getFormComponentStyle = (props: Dict): CSSObject => ({
  _hover: {
    '&:not([disabled])': {
      ...commonBackgroundColor(props),
    },
    _placeholder: {
      color: mode('rw1.text.light.1', 'rw1.text.dark.1')(props),
    },
  },
  _active: {
    '&:not([disabled])': {
      ...activeStyle(props),
    },
  },
  _placeholder: {
    color: mode('rw1.text.light.0', 'rw1.text.dark.0')(props),
    fontStyle: 'italic',
  },
  _disabled: {
    opacity: DISABLED_OPACITY,
  },
  _invalid: {
    borderColor: mode('rw1.colors.light.red', 'rw1.colors.dark.red')(props),
  },
  _focus: {
    '&:not([disabled])': {
      ...activeStyle(props),
    }
  },
  ...commonBackgroundColor(props),
  color: mode('rw1.text.light.6', 'rw1.text.dark.6')(props),
  fontWeight: '500',
  borderRadius: '2xl',
  borderWidth: 'thin',
  borderColor: mode('rw1.secondary.light.0', 'rw1.secondary.dark.0')(props),
})
